export default {
	title: 'Plan stratégique',
	tabs: {
		general: {
			title: 'Général'
		},
		filters: {
			title: 'Filtres'
		},
		bot: {
			title: 'IA'
		},
		export: {
			title: 'Exporter'
		},
		display: {
			title: 'Affichage'
		}
	},
	filters: {
		responsible: {
			title: 'Filtre par responsable',
			placeholder: 'Nom du responsable'
		},
		completion: {
			title: "Filtre d'achèvement",
			not_started: 'Non commencé',
			in_progress: 'En cours',
			completed: 'Terminé'
		},
		dates: {
			title: 'Filtre des dates'
		},
		startOn: {
			title: 'Filtre de date de début',
			undefined: 'Aucune date',
			past: 'Passé',
			ending_week: 'Commence dans une semaine',
			ending_month: 'Commence dans un mois',
			ending_quarter: 'Commence dans un trimestre',
			ending_year: 'Commence dans un an'
		},
		endOn: {
			title: 'Filtre de date de fin',
			undefined: 'Aucune date',
			done: 'Terminé',
			overdue: 'En retard',
			ending_week: 'Se termine dans une semaine',
			ending_month: 'Se termine dans un mois',
			ending_quarter: 'Se termine dans un trimestre',
			ending_year: 'Se termine dans un an'
		}
	},

	display: {
		sort: {
			title: 'Tri des arêtes',
			startOn: 'Par date de début',
			name: 'Par nom',
			manual: 'Ordre manuel'
		}
	},
	all_icons: 'Filtre des icônes',
	no_icon: 'Aucune icône',
	onboarding: {
		title: "Revue du plan d'action",
		description:
			"Vérifiez que les axes et items correspondent à votre lecture du plan."
	}
};
